import { render, staticRenderFns } from "./HkIdCardInput.vue?vue&type=template&id=5870545f&scoped=true&"
import script from "./HkIdCardInput.vue?vue&type=script&lang=js&"
export * from "./HkIdCardInput.vue?vue&type=script&lang=js&"
import style0 from "./HkIdCardInput.vue?vue&type=style&index=0&id=5870545f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5870545f",
  null
  
)

export default component.exports